<template lang="pug">
  .year-quiz
    flip-card(
      @flip="onFlip"
      :disabled="state === states.answer || state === states.done || state === states.finished"
      )
      template(v-slot:front)
        card-back
          span.month(
            v-if="state === states.start"
            )
            | {{ quiz.month.abbrev[locale] }}
          quiz-answer(
            v-else
            @done="result => updateState(states.done, result)"
          )
      template(v-slot:back)
        card-front(
          :number="number"
          :title="quiz.month.title[locale]"
          :text="quiz.month ? quiz.month.data.description[locale] : ''"
          )
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import FlipCard from './FlipCard'
import CardFront from './CardFront'
import CardBack from './CardBack'
import QuizAnswer from './QuizAnswer'

const states = {
  start: 0,
  showMonth: 1,
  answer: 2,
  done: 3,
  finished: 4
};

export default {
  components:{
    FlipCard,
    CardFront,
    CardBack,
    QuizAnswer
  },
  props: {
    quiz: Object
  },
  data() {
    return {
      states,
      state: states.start
    };
  },
  methods: {
    ...mapGetters('weekdays', ['numberByKey']),
    onFlip({ flipped }) {
      if (flipped && this.state === this.states.start) {
        this.updateState(this.states.showMonth);
      }
      if (!flipped && this.state === this.states.showMonth) {
        this.updateState(this.states.answer);
      }
    },
    updateState(state, value=null) {
      if (this.state === this.states.finished) {
        return;
      }
      this.state = state;
      if (this.state === this.states.done) {
        this.$emit('done', this.quiz, value);
        this.state = this.states.finished;
      }
    }
  },
  watch: {
    quiz: function (newQuiz, oldQuiz) {
      if (newQuiz.id !== oldQuiz.id) {
        this.state = this.states.start;
      }
    }
  },
  computed: {
    ...mapState('locale', ['locale']),
    number() {
      return this.numberByKey()(this.quiz.month.data.key)
    }
  }
}
</script>

<style lang="stylus" scoped>
  span.month
    text-transform uppercase
    font-font-weight 900
    font-size 28px
</style>
